import {t} from '../../src/service/locale'

const state = {
  configuration: null,
  countries: [],
  languages: [],
  theme: null,
  snackBar: {},
  isAuthorized: false,
};

const getters = {
  configuration: state => {
    return state.configuration;
  },
  countries: state => {
    return state.countries;
  },
  languages: state => {
    return state.languages;
  },
  theme: state => {
    return state.theme;
  },
  isAuthorized: state => {
    return state.isAuthorized;
  },
};

const mutations = {
  configuration: (state, configuration) => {
    state.configuration = configuration;
  },
  countries: (state, countryList) => {
    state.countries = countryList;
  },
  languages: (state, languageList) => {
    state.languages = languageList;
  },
  theme: (state, value) => {
    state.theme = value;
  },
  CALL_TOAST: (state, toastMessage) => {
    state.snackBar = toastMessage;
  },
  SET_AUTHORIZED: (state, isAuthorized) => {
    state.isAuthorized = isAuthorized;
  }
};

const actions = {
  toastMessage({ commit }, message) {
    commit("CALL_TOAST", message);
  },
  selectedCamera({ commit }, message) {
    commit("CALL_CAMERA", message);
  },
  setAuthorized({ commit }, data) {
    commit("SET_AUTHORIZED", data);
  },
  demoMessage({ commit }, message) {
    commit("CALL_TOAST", 
    {
      showing: true,
      text: t(message  ? message : "As a demo user you can't perform this action."),
      timeout: -1,
      color: "error",
      support: true
    })
  },
};
export default {
  state,
  getters,
  mutations,
  actions
};
